/* global $:false */

export default class MarketLotShowBidExplanation {
  static init () {
    Array.from($('.js-market-lot-show-bids')).map((el) =>
      new MarketLotShowBidExplanation(el))
  }

  constructor (el) {
    this.el = $(el)
    this.findElements()
    this.setupBindings()
  }

  findElements () {
    this.allFoldouts = $('.js-market-lot-show-bids__explanation')
    this.foldout = this.el.find('.js-market-lot-show-bids__explanation')
  }

  setupBindings () {
    this.el.click(event => {
      event.preventDefault()
      if (this.foldout.is(':visible')) {
        this.allFoldouts.hide()
      } else {
        this.allFoldouts.hide()
        this.foldout.show()
      }
    })
  }
}
